import styled from 'styled-components';
import { IconMenuHamburger } from '@prisjakt/ui/icon/menu-hamburger';
import { media, remCalc } from 'src/components/base';

type MenuButtonProps = {
  active?: boolean;
};

export const MenuButton = styled.button.attrs({ type: 'button' })<
  MenuButtonProps
>`
  color: ${props => props.theme.header.fg};
  line-height: inherit;
  text-align: left;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  display: flex;
  position: relative;

  ${media.largeUp`
    display: none;
  `};

  &.focus-visible {
    background: ${p => (p.active ? 'white' : p.theme.buttons.primary.bg)};
  }
`;

export const MenuIcon = styled(IconMenuHamburger).attrs({
  size: 32,
  color: 'base100',
})`
  min-width: ${remCalc(27)};
`;
